@if (visible()) {
  <div>
    <nz-timeline [id]="table.tableCode">
      @for (record of visibleRecords(); track record.recordId) {
        <nz-timeline-item>
          <div class="meta">
            <div class="date">
              {{ record?.recordData?.date }}
            </div>
          </div>
          <div class="title">
            {{ record?.recordData?.activityDescription }}
            @if (record?.recordData?.activityResult === 'approve') {
              <span class="chip chip-approved">Aprobado</span>
            } @else if (record?.recordData?.approvalResult === 'reject') {
              <span class="chip chip-rejected">Rechazado</span>
            } @else if (record?.recordData?.activityResult) {
              <span class="chip chip-pending">{{ record?.recordData?.activityResult }}</span>
            }
          </div>
          <div class="meta">
            <div class="advisor">{{ record?.recordData?.authorFullName }}</div>
            <span class="advisor">{{ record?.recordData?.activityDetail }}</span>
          </div>
        </nz-timeline-item>
      }
    </nz-timeline>
  </div>
  <!-- <div>
    <nz-row [id]="table.tableCode" [nzGutter]="[4, 4]">
      @for (record of visibleRecords(); track record.recordId) {
        <nz-col nzXs="24">
          <div class="cards-container">
            <div class="historyCard">
              <div class="title">
                {{ record?.recordData?.activityDescription }}
              </div>
              <div class="meta">
                <span class="date">
                  {{ record?.recordData?.date }}
                </span>
                <span class="separator">•</span>
                <span class="separator">•</span>
                <span class="advisor">{{ record?.recordData?.authorFullName }}</span>
                <span class="separator">•</span>
                <span class="separator">•</span>
                @if (record?.recordData?.activityResult === 'approve') {
                  <span class="chip chip-approved">Aprobado</span>
                } @else if (record?.recordData?.approvalResult === 'reject') {
                  <span class="chip chip-rejected">Rechazado</span>
                } @else if (record?.recordData?.activityResult) {
                  <span class="chip chip-pending">{{ record?.recordData?.activityResult }}</span>
                }
              </div>
              <div class="meta">
                <span class="advisor">{{ record?.recordData?.activityDetail }}</span>
              </div>
            </div>
          </div>
        </nz-col>
      }
    </nz-row>
  </div> -->
}
